import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SvgMap from '../maps';
import Button from '../button/index';
const CustomMap = ({
  maps,
  isFiltered,
  onReset,
  onChange,
  partiesWinners,
  currentCommunity,
  isRegional,
  allRegions,
  selectedPlace,
  native,
  showDots = false,
  excludedGrandParentIds
}) => {
  const [style, setStyle] = useState();

  const resetMap = () => {
    if (!isRegional) {
      setStyle(null);
    }
    onReset();
  };

  return (
    <div className="mapWrapper">
      <SvgMap
        excludedGrandParentIds={excludedGrandParentIds}
        native={native}
        className="mapa-svg"
        viewVoxStyle={style}
        allRegions={isFiltered ? [] : allRegions}
        partiesWinners={partiesWinners}
        selectedPlace={selectedPlace}
        mapElements={maps}
        onClick={(item, svgEl, event) =>
          onChange(item.parentId, item, true, event)
        }
        currentCommunity={currentCommunity}
        showDots={showDots}
      />
      {isFiltered && <Button onClick={resetMap}> Volver al mapa</Button>}
    </div>
  );
};

CustomMap.propTypes = {
  maps: PropTypes.arrayOf(
    PropTypes.shape({
      svg: PropTypes.string,
      ineId: PropTypes.string,
      main: PropTypes.bool,
      name: PropTypes.string,
      parentId: PropTypes.string,
      typePlace: PropTypes.string
    })
  ),
  mouseEnter: PropTypes.func,
  mouseLeave: PropTypes.func
};

CustomMap.defaultProps = {
  maps: null,
  partiesWinners: null
};

export default CustomMap;
